export const API_BASE_ADDRESS = process.env.REACT_APP_API_BASE_ADDRESS!;
export const API_OPENAI_ADDRESS = "https://api.openai.com/v1/chat/completions";
export const OPENAI_API_KEY ="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";
export const GOOGLE_SHEET_KEY="AKfycbwXT2Lwhl_1vzUnNB8V2YffwDWkODIcf1ntLWQ50Yi9AiC4EXMl1IVa54t04_ptesie";